import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import LoadingCentered from "../../common/loaders/loadingcentered";
import { generateDocxReport } from "../../api";
import { authSelector } from "../../reducers";
import { blobToDataURL, logoFetch, logoUrl } from "../../common/utils";

export function DocxStatement({ data }) {
  const [showLoading, setShowLoading] = useState(false);

  const { companyName, companyAddress1, companyAddress2, companyAddress3, companyEmail, companyUrl, companyLogoUrl, company } = useSelector(authSelector);
  const organizationLogoUrl = company?.logoUrl;

  useEffect(() => {
    async function fetchReport() {
      setShowLoading(true);
      const json = {
        ...data,
        company: {
          name: companyName,
          address1: companyAddress1,
          address2: companyAddress2,
          address3: companyAddress3,
          email: companyEmail,
          url: companyUrl,
          logo: await logoFetch( logoUrl(companyLogoUrl, organizationLogoUrl) ),
        },
      };

      const res = await generateDocxReport("hr-statement", json);

      const a = document.createElement("a");
      a.download = data.fileName;

      const href = URL.createObjectURL(res.data);
      a.href = href;
      a.target = "_blank";

      setShowLoading(false);
      a.click();
      setTimeout(URL.revokeObjectURL, 0, href); // release reference to the file
    }
    fetchReport();
  }, [data]);

  return showLoading && <LoadingCentered show />;
}
